<div class="newEditionTile" mat-dialog-title>Detalle de usuario</div>
<div mat-dialog-content class="newEditionContent">
  <p>Datos de Usuario</p>
  <div fxLayout="row wrap" fxLayoutGap="50px" fxLayout.lt-sm="column">
    <mat-form-field fxFlex="100">
      <input matInput placeholder="Nombre Usuario" [(ngModel)]="user.userName">
    </mat-form-field>
    <mat-form-field fxFlex="100">
      <input matInput placeholder="Ciudad" [(ngModel)]="user.city" >
    </mat-form-field>
    <mat-form-field fxFlex="100">
      <input matInput placeholder="Oficina" [(ngModel)]="user.office">
    </mat-form-field>
  </div>


  <p>Roles</p>
  <div fxLayout="row wrap" fxLayoutGap="50px" fxLayout.lt-sm="column" *ngIf="rolesResp && rolesResp.count > 0">
    <div fxFlex="25" *ngFor="let role of rolesResp.roles" class="flexItem">
      <mat-checkbox [(ngModel)]="role.checked" color="primary">{{role.roleName}}</mat-checkbox>
    </div>
  </div>

  <p>Sucursales</p>

  <div fxLayout="row wrap" fxLayout.lt-sm="column" *ngIf="branchesResp && branchesResp.count > 0">
    <div fxFlex="50" *ngFor="let branch of branchesResp.branches" class="flexItem">
      <mat-checkbox [(ngModel)]="branch.checked" color="primary">{{branch.name}}</mat-checkbox>
    </div>
  </div>
</div>
<div mat-dialog-actions fxLayoutAlign="end start" fxLayoutAlign.lt-sm="center start" class="flexButton">
  <button (click)="saveChanges()" mat-raised-button color="primary">
    <mat-icon>save</mat-icon> Guardar</button>
  <a (click)="onNoClick()" mat-raised-button>
    <mat-icon>cancel</mat-icon> Cancelar</a>
</div>
